import * as React from "react";

import { ILeanSvgIconWithColor } from "../ILeanSvgIconWithColor";

export const arrow_long_right_small: React.FunctionComponent<ILeanSvgIconWithColor> = ({ iconColor, ...rest }) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" {...rest}>
      <path
        fill="none"
        stroke={iconColor}
        d="M4,12.4914 L19.49,12.4914 M16.3486,15.6404 L19.4906,12.4914 L16.3486,9.3504"
      />
    </svg>
  );
};
